import { render, staticRenderFns } from "./PluginPaymentSuccess.vue?vue&type=template&id=345bc8bc&"
import script from "./PluginPaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PluginPaymentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports